// list error message return from BE
export const UNIT_ERROR_MESSAGES = {
  NOT_SAME_EXISTING_COUNTERPARTY: {
    message: '403 - Provided token does not match the existing counterparty details'
  },
  NAME_VALIDATION_FAILS: {
    message: 'Failed name verification'
  }
};

export const LINK_BANK_ERROR_MESSAGE = {
  CAN_NOT_LINK_SAME_BANK_ACCOUNT: {
    message: 'CAN_NOT_LINK_SAME_BANK_ACCOUNT'
  }
};

// list message should be show on the UI
export const PLAID_ERROR_MESSAGES = {
  NOT_SAME_EXISTING_COUNTERPARTY: {
    title: 'This account can no longer be relinked',
    description:
      'The linked bank account details have changed. Please create a new connection instead.'
  },
  CREATE_COUNTERPARTY_FAILS: {
    title: 'Try linking again',
    description: 'There was an error linking with Plaid. Please try again.'
  },
  OTHER_ERROR: {
    title: 'Your account could not be relinked',
    description: 'There was an issue when relinking your account. Please try again.'
  },
  CAN_NOT_LINK_SAME_BANK_ACCOUNT: {
    title: 'Bank account cannot be linked',
    description: 'You cannot link to the same bank account. Please try again.'
  }
};

/**
 * Create error object
 *
 * @param {string} message : message from gql error
 * @param {boolean} isCreateNew : is true if going to create new a counterparty account
 * @returns {object} with { title, description }
 */
export const createErrorObject = (message, isCreateNew) => {
  switch (message) {
    case UNIT_ERROR_MESSAGES.NOT_SAME_EXISTING_COUNTERPARTY.message:
      return PLAID_ERROR_MESSAGES.NOT_SAME_EXISTING_COUNTERPARTY;
    case UNIT_ERROR_MESSAGES.NAME_VALIDATION_FAILS.message:
      return UNIT_ERROR_MESSAGES.NAME_VALIDATION_FAILS.message;
    case LINK_BANK_ERROR_MESSAGE.CAN_NOT_LINK_SAME_BANK_ACCOUNT.message:
      return PLAID_ERROR_MESSAGES.CAN_NOT_LINK_SAME_BANK_ACCOUNT;
    default:
      return isCreateNew
        ? PLAID_ERROR_MESSAGES.CREATE_COUNTERPARTY_FAILS
        : PLAID_ERROR_MESSAGES.OTHER_ERROR;
  }
};

export const CREATE_PAYEES_PLAID_SPECIFIC_ERRORS = ['ACCOUNT_ALREADY_LINKED'];
